import getCountry from '@/utils/getCountry.js'
import { buy_link } from '@/scripts/constant.js'
const region = getCountry()

export const footer_list_message = [
  {
    title: "menu.products", //intl.formatMessage({ id: "menu.products" }),
    list: [
      {
        key: "onepro",
        name: "One Pro",
        translate: false,
        link: "/one-pro",
        outlink: false
      },
      {
        key: "eye",
        name: "Eye",
        translate: false,
        link: "/eye/",
        outlink: false
      },
      {
        key: "one",
        name: "One",
        translate: false,
        link: "/one",
        outlink: false
      },
      {
        key: "beampro",
        name: "Beam Pro",
        translate: false,
        link: "/beampro",
        outlink: false
      },
      {
        key: "air2ultra",
        name: "Air 2 Ultra",
        translate: false,
        link: "/air2ultra",
        outlink: false
      },
      {
        key: "air2",
        name: "Air 2 / Pro",
        translate: false,
        link: "/air2",
        outlink: false
      },
      {
        key: "hub",
        name: "Hub",
        translate: false,
        link: buy_link[region]["hub"].shop,
        outlink: true
      }
    ]
  },
  {
    title: "footernew_social", //intl.formatMessage({ id: "footernew_social" }),
    list: [{
        key: "x",
        name: "X",
        translate: false,
        link: region=='jp' ? process.env.url_twitter_jp : process.env.url_twitter,
        outlink: true
      },
      {
        key: "instagram",
        name: "Instagram",
        translate: false,
        link: region=='jp' ? process.env.url_ins_jp : process.env.url_ins,
        outlink: true
      },
      {
        key: "reddit",
        name: "Reddit",
        translate: false,
        link: process.env.url_reddit,
        outlink: true
      },
      {
        key: "youtube",
        name: "YouTube",
        translate: false,
        link: region=='jp' ? process.env.url_youtube_jp : process.env.url_youtube,
        outlink: true
      },
      {
        key: "discord",
        name: "Discord",
        translate: false,
        link: region=='jp' ? process.env.url_discord_jp : process.env.url_discord,
        outlink: true
      }
    ]
  },
  {
    title: "menu.support", //intl.formatMessage({ id: "menu.support" }),
    list: [
      {
        key: "firmwareupgrade",
        name: "homenew_support2_title", //intl.formatMessage({ id: "homenew_support2_title" }),
        translate: true,
        link: "https://www.xreal.com/ota/",
        outlink: false
      },
      {
        key: "faq",
        name: "FAQ_text", //intl.formatMessage({ id: "FAQ_text" }),
        translate: true,
        link: "",
        outlink: false
      },
      {
        key: "campare",
        name: "homenew_support1_title", //intl.formatMessage({ id: "homenew_support1_title" }),
        translate: true,
        link: "/glasses/compare",
        outlink: false
      },
      {
        key: "userguide",
        name: "footernew_userguide", //intl.formatMessage({ id: "footernew_userguide" }),
        translate: true,
        link: "",
        outlink: false
      }
    ]
  },
  {
    title: "footerList.developer", //intl.formatMessage({ id: "footerList.developer" }),
    list: [
      {
        key: "developerhome",
        name: "footer.developerhome", //intl.formatMessage({ id: "footer.developerhome" }),
        translate: true,
        link: process.env.url_developer,
        outlink: true
      },
      {
        key: "sdk",
        name: "footerList.sdk_download", //intl.formatMessage({ id: "footerList.sdk_download" }),
        translate: true,
        link: `${process.env.url_developer}/download`,
        outlink: true
      }
    ]
  },
  {
    title: "footerList.about", //intl.formatMessage({ id: "footerList.about" }),
    list: [
      {
        key: "news",
        name: "footerList.news", //intl.formatMessage({ id: "footerList.news" }),
        translate: true,
        link: "/news",
        outlink: false
      },
      {
        key: "about",
        name: "footer.aboutus", //intl.formatMessage({ id: "footer.aboutus" }),
        translate: true,
        link: "/about",
        sensorID: "",
        gaID: "About Us",
        outlink: false
      },
      {
        key: "contactus",
        name: "footerList.contact", //intl.formatMessage({ id: "footerList.contact" }),
        translate: true,
        link: "/contact-us",
        outlink: false
      },
      {
        key: "career",
        name: "footerList.join", //intl.formatMessage({ id: "footerList.join" }),
        translate: true,
        link: "/career",
        outlink: false
      },
      {
        key: "distributor",
        name: "distributor_title", //intl.formatMessage({ id: "distributor_title" }),
        translate: true,
        link: "/distributors",
        outlink: false
      },
      {
        key: "pioneers",
        name: "footernew_pioneers", //intl.formatMessage({ id: "footernew_pioneers" }),
        translate: true,
        link: "/pioneers",
        outlink: false
      }
    ]
  }
]

export const footer_list_message_jp = [
  {
    title: 'menu.products', //intl.formatMessage({ id: , defaultMessage: 'PRODUCTS' }),
    list: [
      {
        key: "onepro",
        name: "One Pro",
        translate: false,
        link: "/one-pro",
        outlink: false
      },
      {
        key: "one",
        name: "One",
        translate: false,
        link: "/one",
        sensorID: "",
        gaID: "One",
        outlink: false
      },
      {
        key: "air2ultra",
        name: "Air 2 Ultra",
        translate: false,
        link: "/air2ultra",
        sensorID: "",
        gaID: "Air 2 Ultra",
        outlink: false
      },
      {
        key: "air2",
        name: "Air 2 / Pro",
        translate: false,
        link: "/air2",
        sensorID: "",
        gaID: "Air 2 / Pro",
        outlink: false
      },
      {
        key: "air",
        name: "Air",
        translate: false,
        link: "/air",
        sensorID: "",
        gaID: "Air",
        outlink: false
      }, {
        key: "beampro",
        name: "XREAL Beam Pro",
        translate: false,
        link: "/beampro",
        sensorID: "",
        gaID: "XREAL Beam Pro",
        outlink: false
      }, {
        key: "beam",
        name: "Beam",
        translate: false,
        link: "/beam",
        sensorID: "",
        gaID: "Beam",
        outlink: false
      }, {
        key: "hub",
        name: "Hub",
        translate: false,
        link: buy_link[region]['hub'].shop,
        sensorID: "",
        gaID: "Hub",
        outlink: true
      },
      {
        key: "adapter",
        name: "Adapter",
        translate: false,
        link: "/adapter",
        sensorID: "",
        gaID: "Adapter",
        outlink: false
      }
    ]
  }, {
    title: 'footer.social', //intl.formatMessage({ id: 'footer.social', defaultMessage: 'SOCIAL' }),
    list: [{
        key: "x",
        name: "X",
        translate: false,
        link: region=='jp' ? process.env.url_twitter_jp : process.env.url_twitter,
        outlink: true
      },
      {
        key: 'instagram',
        name: "Instagram",
        translate: false,
        link: region == 'jp' ? process.env.url_ins_jp : process.env.url_ins,
        sensorID: "",
        gaID: "Instagram",
        outlink: true
      }, {
        key: "reddit",
        name: "Reddit",
        translate: false,
        link: process.env.url_reddit,
        sensorID: "",
        gaID: "Reddit",
        outlink: true
      }, {
        key: "youtube",
        name: "Youtube",
        translate: false,
        link: region == 'jp' ? process.env.url_youtube_jp : process.env.url_youtube,
        sensorID: "",
        gaID: "Youtube",
        outlink: true
      },
      {
        key: "discord",
        name: "Discord",
        translate: false,
        link: region=='jp' ? process.env.url_discord_jp : process.env.url_discord,
        outlink: true
      }
    ]
  }, {
    title: "footerList.developer", //intl.formatMessage({ id: "footerList.developer", defaultMessage: 'Developer' }),
    list: [
      {
        key: "developer",
        name: "footer.developerhome", //intl.formatMessage({ id: "footer.developerhome", defaultMessage: 'Developer Home' }),
        translate: true,
        link: process.env.url_developer,
        sensorID: "",
        gaID: "Developer Home",
        outlink: true
      },
      {
        key: "sdk",
        name: "footerList.sdk_download", //intl.formatMessage({ id: "footerList.sdk_download", defaultMessage: 'SDK Download' }),
        translate: true,
        link: `${process.env.url_developer}/download`,
        sensorID: "",
        gaID: "SDK Download",
        outlink: true
      }, {
        key: "discord",
        name: "footerList.discord", //intl.formatMessage({ id: "footerList.discord", defaultMessage: 'Discord' }),
        translate: true,
        link: region == 'jp' ? process.env.url_discord_jp : process.env.url_discord,
        sensorID: "",
        gaID: "Discord",
        outlink: true
      }
    ]
  }, {
    title: "footerList.about", //intl.formatMessage({ id: "footerList.about", defaultMessage: 'About' }),
    list: [
      {
        key: "news",
        name: 'News',
        translate: false,
        link: "/news",
        sensorID: "",
        gaID: "News",
        outlink: false
      },
      {
        key: "about",
        name: "footer.aboutus", //intl.formatMessage({ id: "footer.aboutus", defaultMessage: 'About Us' }),
        translate: true,
        link: "/about",
        sensorID: "",
        gaID: "About Us",
        outlink: false
      },
      {
        key: "contact",
        name:  "footerList.contact", //intl.formatMessage({ id: "footerList.contact", defaultMessage: 'Contact Us' }),
        translate: true,
        link: "/contact-us",
        sensorID: "",
        gaID: "Contact Us",
        outlink: false
      },
      {
        key: "career",
        name: "footerList.join", //intl.formatMessage({ id: "footerList.join", defaultMessage: 'Join Us' }),
        translate: true,
        link: "/career",
        sensorID: "",
        gaID: "Join Us",
        outlink: false
      }, {
        key: "distributors",
        name: "distributor_title", //intl.formatMessage({ id: "distributor_title" }),
        translate: true,
        link: "/distributors",
        sensorID: "",
        gaID: "Retailers & Distributors",
        outlink: false
      },
      {
        key: "pioneers",
        name: "Pioneers Program",
        translate: false,
        link: "/pioneers",
        sensorID: "",
        gaID: "Pioneers Program",
        outlink: false
      }, {
        key: "airstores",
        name: '体験店舗リスト',
        translate: false,
        link: "/stores",
        sensorID: "",
        gaID: "air stores",
        outlink: false
      }
    ]
  },
]

export const footer_list_message_kr = [
  {
    title: 'menu.products', //intl.formatMessage({ id: 'menu.products', defaultMessage: 'PRODUCTS' }),
    list: [
      {
        key: "one",
        name: "One",
        translate: false,
        link: "/one",
        sensorID: "",
        gaID: "One",
        outlink: false
      },
      {
        key: "air2ultra",
        name: "Air 2 Ultra",
        translate: false,
        link: "/air2ultra",
        sensorID: "",
        gaID: "Air 2 Ultra",
        outlink: false
      },
      {
        key: "air2",
        name: "Air 2 / Pro",
        translate: false,
        link: "/air2",
        sensorID: "",
        gaID: "Air 2 / Pro",
        outlink: false
      },
      {
        key: "air",
        name: "Air",
        translate: false,
        link: "/air",
        sensorID: "",
        gaID: "Air",
        outlink: false
      }, {
        key: "beampro",
        name: "XREAL Beam Pro",
        translate: false,
        link: "/beampro",
        sensorID: "",
        gaID: "XREAL Beam Pro",
        outlink: false
      }, {
        key: "beam",
        name: "Beam",
        translate: false,
        link: "/beam",
        sensorID: "",
        gaID: "Beam",
        outlink: false
      },
      {
        key: "adapter",
        name: "Adapter",
        translate: false,
        link: "/adapter",
        sensorID: "",
        gaID: "Adapter",
        outlink: false
      }
    ]
  }, {
    title: 'footer.social', //intl.formatMessage({ id: 'footer.social', defaultMessage: 'SOCIAL' }),
    list: [{
        key: "x",
        name: "X",
        translate: false,
        link: region=='jp' ? process.env.url_twitter_jp : process.env.url_twitter,
        outlink: true
      },
      {
        key: 'instagram',
        name: "Instagram",
        translate: false,
        link: region == 'jp' ? process.env.url_ins_jp : process.env.url_ins,
        sensorID: "",
        gaID: "Instagram",
        outlink: true
      }, {
        key: "reddit",
        name: "Reddit",
        translate: false,
        link: process.env.url_reddit,
        sensorID: "",
        gaID: "Reddit",
        outlink: true
      }, {
        key: "youtube",
        name: "Youtube",
        translate: false,
        link: region == 'jp' ? process.env.url_youtube_jp : process.env.url_youtube,
        sensorID: "",
        gaID: "Youtube",
        outlink: true
      },
      {
        key: "discord",
        name: "Discord",
        translate: false,
        link: region=='jp' ? process.env.url_discord_jp : process.env.url_discord,
        outlink: true
      }
    ]
  }, {
    title: "footerList.developer", //intl.formatMessage({ id: "footerList.developer", defaultMessage: 'Developer' }),
    list: [
      {
        key: "developer",
        name: "footer.developerhome", //intl.formatMessage({ id: "footer.developerhome", defaultMessage: 'Developer Home' }),
        translate: true,
        link: process.env.url_developer,
        sensorID: "",
        gaID: "Developer Home",
        outlink: true
      },
      {
        key: "sdk",
        name: "footerList.sdk_download", //intl.formatMessage({ id: "footerList.sdk_download", defaultMessage: 'SDK Download' }),
        translate: true,
        link: `${process.env.url_developer}/download`,
        sensorID: "",
        gaID: "SDK Download",
        outlink: true
      }, {
        key: "discord",
        name: "footerList.discord", //intl.formatMessage({ id: "footerList.discord", defaultMessage: 'Discord' }),
        translate: true,
        link: region == 'jp' ? process.env.url_discord_jp : process.env.url_discord,
        sensorID: "",
        gaID: "Discord",
        outlink: true
      }
    ]
  }, {
    title: "footerList.about", //intl.formatMessage({ id: "footerList.about", defaultMessage: 'About' }),
    list: [
      {
        key: "about",
        name: "footer.aboutus", //intl.formatMessage({ id: "footer.aboutus", defaultMessage: 'About Us' }),
        translate: true,
        link: "/about",
        sensorID: "",
        gaID: "About Us",
        outlink: false
      },
      {
        key: "contact",
        name: "footerList.contact", //intl.formatMessage({ id: "footerList.contact", defaultMessage: 'Contact Us' }),
        translate: true,
        link: "/contact-us",
        sensorID: "",
        gaID: "Contact Us",
        outlink: false
      },
      {
        key: "career",
        name: "footerList.join", //intl.formatMessage({ id: "footerList.join", defaultMessage: 'Join Us' }),
        translate: true,
        link: "/career",
        sensorID: "",
        gaID: "Join Us",
        outlink: false
      }, {
        key: "distributors",
        name: "distributor_title", //intl.formatMessage({ id: "distributor_title" }),
        translate: true,
        link: "/distributors",
        sensorID: "",
        gaID: "Retailers & Distributors",
        outlink: false
      },
      {
        key: "pioneers",
        name: "Pioneers Program",
        translate: false,
        link: "/pioneers",
        sensorID: "",
        gaID: "Pioneers Program",
        outlink: false
      }
    ]
  }
]

export const REGION_TO_FOOTER_MAP = {
  kr: footer_list_message_kr,
  jp: footer_list_message_jp,
  default: footer_list_message
}
